import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // treat data fresh for 30s — avoids refetch storms
      retry: 1, // BFF auth errors (401/403) shouldn't be hammered
      refetchOnWindowFocus: false,
    },
  },
})
